module.exports = {"pathContext":{"slug":"/es/protections-coverages/","langKey":"es"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/es-protections-coverages.json
// module id = 1231
// module chunks = 273977039715485